import script from "./AdminCompletedFormsListView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminCompletedFormsListView.vue?vue&type=script&setup=true&lang=js"

import "./AdminCompletedFormsListView.vue?vue&type=style&index=0&id=3db16180&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3db16180"]])

export default __exports__